import api from "../../../api";
import { isEmptyString } from "../../../utils/stringUtils";

export const isEmptyMeasure = ({ title, description }: api.CreateMeasureRequest) =>
  isEmptyString(title) && isEmptyString(description);

export const isCustomMeasure = (measure: api.Measure) => measure.measure_config_id === undefined;
